var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i18n',{staticClass:"has-margin-bottom-100",attrs:{"tag":"p","path":"_sentence.forgotten_password_instructions"}}),_vm._v(" "),_c('forgotten-password-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }